    import api from '../../api/index.js'

    const state = {

    }

    const getters = {

    }

    const actions = {
        IsPhoneAuth({commit},payload){
            return new Promise((resolve,reject) => {
                api.get('/MemberPhoneAuth/IsPhoneAuth',payload, res => {
                    resolve(res.Result)
                }, err => {
                    reject(err)
                }) 
            });
        },
        MemberPhoneAuthPost({commit},payload) {
            return new Promise((resolve, reject) => {
                api.post('/MemberPhoneAuth/Post',payload, res => {                
                    resolve(res.Result);
                }, err => {
                    reject(err);
                })
            })
        },
    }

    const mutations = {

    }

    export default {
        state,
        getters,
        actions,
        mutations
    }
